
<search-list-new
  #searchList
  matSort
  [defaultSort]="{
    active: 'dueDate',
    direction: 'desc'
  }"
  [showManagerToggle]="false"
  [resultGetter]="search.bind(this)"
  [displayedColumns]="displayedColumns"
  (itemSelected)="onSelect($event)"
  localStorageId="my-tickets-queue"
  [hideSearchBar]="true"
>
<!--   <ng-container matColumnDef="assigned">
    <mat-header-cell *matHeaderCellDef style="max-width: 5%">Assignee</mat-header-cell>
    <mat-cell *matCellDef="let row" style="max-width: 5%">
      <div class="d-flex align-items-center w-100">
        {{row.assignedUser?.fullName}}
        <mat-chip selected color="accent" class="small font-weight-bold ml-auto mr-2" *ngIf="isCCd(row)">
          <mat-icon svgIcon="account-supervisor" matPrefix></mat-icon>
          CCd
        </mat-chip>
      </div>
    </mat-cell>
  </ng-container -->>
  <ng-container matColumnDef="department">
    <mat-header-cell *matHeaderCellDef style="max-width: 10%">Department</mat-header-cell>
    <mat-cell *matCellDef="let row" style="max-width: 10%">
      <span *ngIf="row.department" class="font-weight-bold">
        {{row.department}}
      </span>
      <span class="text-muted" *ngIf="!row.department">
        —
      </span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="ticketName">
    <mat-header-cell *matHeaderCellDef style="max-width: 15%">Ticket #</mat-header-cell>
    <mat-cell *matCellDef="let row" style="max-width: 15%">
      <span class="font-weight-bold mat-light-text">
        {{row.ticketName}}
      </span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="description">
    <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <span class="mat-light-text">
        {{row.description}}
      </span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="dueDate">
    <mat-header-cell *matHeaderCellDef style="max-width: 20%">Due Date</mat-header-cell>
    <mat-cell *matCellDef="let row" style="max-width: 20%">
      <ng-container *ngIf="row.dueDate">
        <span class="font-weight-medium">
          {{row.dueDate | date: 'MM/dd/yyyy' }}
        </span> 
        <mat-chip class="small ml-2 font-weight-medium" [ngClass]="daysLeftColorClass(row.dueDate)" *ngLet="daysLeft(row.dueDate, true) as dayCount">
          <ng-container *ngIf="dayCount !== 0">
            {{dayCount}} Day(s)
            {{(daysLeft(row.dueDate, false)||0) >= 0 ? 'From Today':'Overdue'}}
          </ng-container>
          <ng-container *ngIf="dayCount === 0">
            Due Today
          </ng-container>
        </mat-chip>
      </ng-container>
      <ng-container *ngIf="!row.dueDate">
        <div class="text-muted">—</div>
      </ng-container>
    </mat-cell>
  </ng-container>
</search-list-new>
